import 'wicg-inert';
import { Card04LineClamp } from '../ist/components/card04/_lineClamp';
import { CardLargeLineClamp } from '../ist/components/cardLarge/_lineClamp';
import { CardMiddleLineClamp } from '../ist/components/cardMiddle/_lineClamp';
import { CardSmallLineClamp } from '../ist/components/cardSmall/_lineClamp';
import { CustomLinkManager } from '../ist/components/customLink/_customLink';
import { DetailCloseManager } from '../ist/components/detailClose/_detailClose';
import { DetailAnimationManager } from '../ist/components/detailsAnimation/_detailsAnimation';
import { Device } from '../ist/components/device/_device';
import HorizontalScroll from '../ist/components/horizontalScroll/_horizontalScroll';
import { ImageMapManager } from '../ist/components/imageMap/_imageMapManager';
import Lightbox from '../ist/components/lightbox/_lightbox';
import { Modal } from '../ist/components/modal/_modal';
import { OpenCloseManager } from '../ist/components/openClose/_openClose';
import ProductsNavHeight from '../ist/components/projuctsNavItem/_productsNavHeight';
import ProductsNavToggleSp from '../ist/components/projuctsNavItem/_productsNavToggleSp';
import ProductsNavTooltip from '../ist/components/projuctsNavItem/_productsNavTooltip';
import { ProjuctsNavItemToggleManager } from '../ist/components/projuctsNavItem/_projuctsNavItem';
import { ProductsNavSp } from '../ist/components/projuctsNavItem/_projuctsNavSp';
import { RandomViewManager } from '../ist/components/randomView/_randomView';
import { SetHeightManager } from '../ist/components/setHeight/_setHeight';
import Slider from '../ist/components/slider/_slider';
import StoryKV from '../ist/components/storyKeyVisual/_storyKeyVisual';
import { TabsManager } from '../ist/components/tabsManager/_tabsManager';
import WidthWrapper from '../ist/components/widthWrapper/_widthWrapper';
import { WindowSizeManager } from '../ist/components/windowWight/_windowWight';
import { BrowserDetector } from '../ist/components/browser/_browser';
import { StickyContentManagerGroup } from '../ist/components/titleStickyContent/_titleStickyContent';
import { ImageLinkManager } from '../ist/components/aTag/_aTag';

// デバイス
const device = new Device();

// ブラウザ判定
BrowserDetector.detect();

// randomView
const randomView = new RandomViewManager();

/**
 * DOMContentLoaded とは
 * ページの読み込みが完了した時に発生するイベント
 * このイベントが発生した時に初期化処理を行う
 */
document.addEventListener('DOMContentLoaded', () => {
  // 読み込み完了したら htmlタグに ist-loaded クラスを追加
  document.documentElement.classList.add('ist-loaded');

  // ウィンドウサイズを管理するマネージャークラス
  const windowManager = new WindowSizeManager();

  // widthWrapper
  const widthWrapper = new WidthWrapper();

  // storyKeyVisual
  const storyKeyVisual = new StoryKV();

  // cardSmall テキストの行数を制限
  const cardSmallLineClamp = new CardSmallLineClamp({ debug: false });

  // customLink
  const customLink = new CustomLinkManager();

  // cardMiddle テキストの行数を制限
  const cardMiddleLineClamp = new CardMiddleLineClamp({ debug: true });

  // card04 テキストの行数を制限
  const card04LineClamp = new Card04LineClamp({ debug: false });

  // cardLarge テキストの行数を制限
  const cardLargeLineClamp = new CardLargeLineClamp({ debug: false });

  // lightbox
  const lightbox = new Lightbox('.ist-js__lightbox');

  // slider
  const slider = new Slider('.ist-slider .splide');

  // horizontalScroll
  const horizontalScroll = new HorizontalScroll();

  // tab
  const tabManager = new TabsManager();

  // setHeight
  const setHeight = new SetHeightManager();

  // projuctsNavHeight
  const projuctsNavHeight = new ProductsNavHeight();

  // projuctsNavItem
  const projuctsNavItem = new ProjuctsNavItemToggleManager();

  // projuctsNavTooltip
  const projuctsNavTooltip = new ProductsNavTooltip();

  // projuctsNavSp
  const navSp = new ProductsNavSp();

  // projuctsNavToggleSp
  const toggleSp = new ProductsNavToggleSp();

  // ProductsNavSp からフォーカスマネージャインスタンスを取得し、ToggleSp にセット
  toggleSp.setNavFocusManagers(navSp.getFocusManagers());

  // imageMap
  const imageMap = new ImageMapManager({ enabled: false });

  // modal
  const modal = new Modal();

  // detailClose
  const detailClose = new DetailCloseManager();

  // detailAnimation
  const animationManager = DetailAnimationManager.getInstance();
  const closeManager = new DetailCloseManager();

  // openClose
  const openClose = new OpenCloseManager();

  // StickyContent
  const stickyContent = new StickyContentManagerGroup(true);

  // main, article内の画像リンク処理
  const imageLinkManager = new ImageLinkManager();
  document.querySelectorAll('main, article').forEach((container) => {
    imageLinkManager.processContainer(container);
  });
});
